
export enum PepColorType {
    AnyColor,
    MainColor,
    SuccessColor,
    CautionColor
}